<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row align="center">
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ editorLabel }}</v-col>
        <v-col class="py-0">
          <v-row>
            <v-tabs
              v-model="activeTab"
              background-color="grey lighten-3 justify-start"
              right
            >
              <v-tab key="details" ripple>Details</v-tab>
              <v-tab key="access" ripple>Access</v-tab>
              <v-tab
                key="settings"
                ripple
                v-if="$store.getters.hasAccessTo('third_party:setup')"
                >Third Party Setups</v-tab
              >
            </v-tabs>
          </v-row>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-tabs-items fixed-tabs v-model="activeTab">
        <v-tab-item key="details">
          <user-editor-details
            :user="updatedUser"
            :userEditorDialog="userEditorDialog"
            :touchDetails="touchDetails"
            :usernameTakenError="usernameTakenError"
            @onTouchDetails="onTouchDetails"
            @onChange="onChangeDetails(...arguments)"
          ></user-editor-details>
        </v-tab-item>
        <v-tab-item key="access">
          <access-settings-editor
            v-model="updatedUser.accessSettings"
          ></access-settings-editor>
        </v-tab-item>
        <v-tab-item
          key="settings"
          v-if="$store.getters.hasAccessTo('third_party:setup')"
        >
          <third-party-setups-for-level
            level="user"
          ></third-party-setups-for-level>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-card-actions class="grey lighten-4">
      <v-flex class="text-right mr-2">
        <v-btn color="warning" @click="$emit('cancel')" text>Cancel</v-btn>
        <v-btn color="primary" @click="saveUser">Save</v-btn>
      </v-flex>
    </v-card-actions>
    <div v-if="debug">{{ updatedUser }}</div>
  </v-content>
</template>

<script>
import UserEditorDetails from "./UserEditorDetails";
import { SaveGqlObjectMixin } from "../../../../mixins/SaveGqlObjectMixin.js";
import AccessSettingsEditor from "../AccessSettingsEditor";
import ThirdPartySetupsForLevel from "../../shared/third-party-setups/ThirdPartySetupsForLevel.vue";

export default {
  name: "UserEditor",
  mixins: [SaveGqlObjectMixin],

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    userEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    AccessSettingsEditor,
    UserEditorDetails,
    ThirdPartySetupsForLevel,
  },

  data() {
    return {
      debug: false,
      updatedUser: { ...this.user },
      activeTab: 0,
      areDetailsValid: true,
      touchDetails: false,
      usernameTakenError: false,
    };
  },

  computed: {
    editorLabel() {
      return this.updatedUser.username ? this.updatedUser.username : "New User";
    },
  },

  methods: {
    onChangeDetails(data, isValid) {
      this.areDetailsValid = isValid;
      this.usernameTakenError = false;
      this.updatedUser.name = data.name;
      this.updatedUser.username = data.username;
      this.updatedUser.password = data.password;
      this.updatedUser.typeId = data.typeId;
      this.updatedUser.email = data.email;
      this.updatedUser.department = data.department;
      this.updatedUser.telephone = data.telephone;
      this.updatedUser.config = data.config;
    },
    saveUser() {
      if (this.checkValidation()) {
        this.$emit("saveUser", { ...this.updatedUser });
      }
    },
    checkValidation() {
      if (this.areDetailsValid) {
        return true;
      } else {
        this.touchDetails = true;
        return false;
      }
    },
    onTouchDetails() {
      this.touchDetails = false;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler(data) {
        if (this.user.id != null) {
          let { __typename, ...item } = data;
          item.accessSettings = item.accessSettings.map((setting) => ({
            groupName: setting.groupName,
            settingName: setting.settingName,
            settingValue: setting.settingValue,
          }));
          this.updatedUser = item;
        }
      },
    },
    userEditorDialog(value) {
      if (!value) {
        this.updatedUser = {};
        this.activeTab = 0;
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/agents/users/UserEditor.vue